if (!customElements.get("variant-picker")) {
  class e extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        container: "[data-variant-picker]",
        productInfo: ".m-product-info--wrapper",
        error: ".m-product-form-message",
        variantIdInput: '[name="id"]',
        pickerFields: ["[data-picker-field]"],
        optionNodes: [".m-product-option--node"],
        productSku: "[data-variant-sku]",
        productAvailability: "[data-availability]",
        shareUrlInput: "[data-share-url]",
        stockCountdown: ".prod__stock-countdown",
        productWrapper: ".m-main-product--wrapper",
      };
      this.container = this.closest(this.selectors.container);
      this.productWrapper = this.closest(this.selectors.productWrapper);
      this.productInfo = this.closest(this.selectors.productInfo);
      this.domNodes = queryDomNodes(this.selectors, this.productInfo);
    }
    connectedCallback() {
      this.setupData();
    }
    async setupData() {
      try {
        let cached = (window._themeProducts || {})[this.container.dataset.productId];
        this.productId = this.container.dataset.productId;
        this.sectionId = this.container.dataset.section;
        this.productUrl = this.container.dataset.productUrl;
        this.productHandle = this.container.dataset.productHandle;
        this.hasOnlyDefaultVariant = "true" === this.dataset.hasOnlyDefaultVariant;
        this.section = this.container.closest(
          `[data-section-id="${this.sectionId}"]`
        );
        this.variantData = this.getVariantData();
        this.productData = Object.assign(
          (await this.getProductJson()) || {},
          cached || {}
        );
        this.showFeaturedMedia = "true" === this.dataset.showFeaturedMedia;
        this.productForm =
          this.productWrapper && this.productWrapper.querySelector("product-form");
        const hasVariantParam = window.location.search.includes("?variant=");
        this.selectedVariantDefault =
          "true" === this.dataset.disableSelectedVariantDefault &&
          this.productData &&
          this.productData.variants &&
          this.productData.variants.length > 1 &&
          !hasVariantParam;
        if (this.selectedVariantDefault) this.disableSelectedVariantDefault();
        this.enableVariantGroupImages =
          "true" === this.container.dataset.enableVariantGroupImages;
        if (this.enableVariantGroupImages) {
          this.variantGroupImages = this.getVariantGroupImageData();
        }
        this.selectedVariant =
          this.productInfo &&
          this.productInfo.querySelector(this.selectors.variantIdInput);
        const selectedId = this.selectedVariant && this.selectedVariant.value;
        this.currentVariant =
          this.productData && this.productData.variants
            ? this.productData.variants.find((v) => v.id === Number(selectedId))
            : null;
        this.productData.current_variant_id =
          this.currentVariant && this.currentVariant.id;
        this.productData.initialVariant = this.currentVariant;
        if (this.currentVariant) {
          this.getDataImageVariant(this.currentVariant.id);
          this.hideSoldOutAndUnavailableOptions();
          this.updateButton(!this.currentVariant.available, "", false);
        }
        this.getMediaGallery();
        document.addEventListener("matchMobile", () => {
          this.getMediaGallery();
        });
        document.addEventListener("unmatchMobile", () => {
          this.getMediaGallery();
        });
      } catch (err) {
        console.error("variant-picker setupData", err);
      }
      try {
        this.initOptionSwatches();
      } catch (err) {
        console.error("variant-picker initOptionSwatches", err);
      }
      this.addEventListener("change", this.onVariantChange);
    }
    disableSelectedVariantDefault() {
      const radios = this.querySelectorAll('input[type="radio"]');
      radios && radios.forEach((el) => (el.checked = false));
      const radioFields = this.querySelectorAll("[data-picker-field='radio']");
      radioFields &&
        radioFields.forEach((el) => {
          el.setAttribute("data-selected-value", "");
        });
      const selectFields = this.querySelectorAll("[data-picker-field='select']");
      selectFields &&
        selectFields.forEach((el) => {
          const select = el.querySelector("select");
          if (select) select.value = "";
          el.setAttribute("data-selected-value", "");
        });
      const labels = this.querySelectorAll(".option-label--selected");
      labels &&
        labels.forEach((el) => {
          el.textContent = "";
        });
      const idInput =
        this.productForm && this.productForm.querySelector("[name='id']");
      if (idInput && !this.hasOnlyDefaultVariant) idInput.value = "";
    }
    getMediaGallery() {
      if (!this.section) return;
      this.mediaGallery = this.section.querySelector("media-gallery");
      this.mediaGalleryMobile = this.section.querySelector("media-gallery-mobile");
      this.check = setInterval(() => {
        if (this.mediaGallery || this.mediaGalleryMobile) {
          clearInterval(this.check);
          if (MinimogTheme.config.mqlMobile) {
            const gallery = this.mediaGalleryMobile || this.mediaGallery;
            this.media = gallery;
            if (!this.slides && gallery.slider) this.slides = gallery.slider.slides;
            if (gallery.navSlider && !this.slidesNav) {
              this.slidesNav = gallery.navSlider.slides;
            }
          } else {
            this.media = this.mediaGallery;
            this.layout = this.mediaGallery.layout;
            if ("slider" === this.mediaGallery.mediaMode) {
              if (!this.slides && this.mediaGallery.slider) {
                this.slides = this.mediaGallery.slider.slides;
              }
              if (this.mediaGallery.navSlider && !this.slidesNav) {
                this.slidesNav = this.mediaGallery.navSlider.slides;
              }
            } else {
              this.mediaItems = this.mediaGallery.querySelectorAll(
                ".m-product-media--item"
              );
            }
          }
          if (
            !this.showFeaturedMedia ||
            (this.enableVariantGroupImages &&
              this.variantGroupImages &&
              this.variantGroupImages.enable)
          ) {
            this.updateMedia();
          }
        }
      }, 100);
    }
    onVariantChange() {
      try {
        this.getSelectedOptions();
        this.getSelectedVariant();
        this.updateButton(true, "", false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.handleBreezeVariant();
        if (this.currentVariant) {
          this.getDataImageVariant(this.currentVariant.id);
          try {
            this.updateMedia();
          } catch (err) {
            console.error("variant-picker updateMedia", err);
          }
          this.updateBrowserHistory();
          this.updateVariantInput();
          this.updateProductMeta();
          try {
            this.updatePrice();
          } catch (err) {
            console.error("variant-picker updatePrice", err);
          }
          this.updateButton(
            !this.currentVariant.available,
            window.MinimogStrings && window.MinimogStrings.soldOut
          );
          this.hideSoldOutAndUnavailableOptions();
        } else {
          this.updateButton(true, "", true);
          this.setUnavailable();
        }
        if (window.MinimogEvents) {
          window.MinimogEvents.emit(
            `${this.productId}__VARIANT_CHANGE`,
            this.currentVariant,
            this
          );
        }
      } catch (err) {
        console.error("variant-picker onVariantChange", err);
      }
    }
    handleBreezeVariant() {
      try {
        const breezeButton =
          this.parentElement &&
          this.parentElement.getElementsByTagName("breeze-button")[0];
        if (!breezeButton) return;
        breezeButton.setAttribute(
          "selectedproductvariantdata",
          btoa(JSON.stringify(this.currentVariant || {}))
        );
        breezeButton.setAttribute(
          "enable",
          this.currentVariant && this.currentVariant.available ? "true" : "false"
        );
      } catch (err) {}
    }
    getDataImageVariant(id) {
      const match =
        this.variantGroupImages &&
        this.variantGroupImages.mapping &&
        this.variantGroupImages.mapping.find((item) => Number(item.id) === id);
      if (
        this.variantGroupImages &&
        this.variantGroupImages.enable &&
        match
      ) {
        this.currentVariantMedia = match.media;
      }
    }
    getProductJson() {
      return fetch(this.productUrl + ".js")
        .then((res) => {
          if (res.ok) return res.json();
          const fallback = this.productWrapper.querySelector(
            "#productData[type='application/json']"
          );
          return fallback ? JSON.parse(fallback.textContent) : {};
        })
        .catch(() => {
          try {
            const fallback = this.productWrapper.querySelector(
              "#productData[type='application/json']"
            );
            return fallback ? JSON.parse(fallback.textContent) : {};
          } catch (err) {
            return {};
          }
        });
    }
    getSelectedVariant() {
      let variant = getVariantFromOptionArray(this.productData, this.options);
      let options = [...this.options];
      if (!variant) {
        options.pop();
        variant = getVariantFromOptionArray(this.productData, options);
        if (!variant) {
          options.pop();
          variant = getVariantFromOptionArray(this.productData, options);
        }
        if (variant && variant.options) {
          this.options = [...variant.options];
          this.updateSelectedOptions();
        }
      }
      this.currentVariant = variant;
    }
    getSelectedOptions() {
      const fields = Array.from(this.querySelectorAll("[data-picker-field]"));
      this.options = fields.map((field) => {
        const type = field.dataset.pickerField;
        if (type === "select") {
          const select = field.querySelector("select");
          return select ? select.value : undefined;
        }
        const checked = Array.from(field.querySelectorAll("input")).find(
          (input) => input.checked
        );
        if (checked) return checked.value;
        const select = field.querySelector("select");
        return select ? select.value : undefined;
      });
    }
    updateSelectedOptions() {
      if (!this.domNodes || !this.domNodes.pickerFields) return;
      this.domNodes.pickerFields.forEach((field, index) => {
        if (!this.options[index]) return;
        if (field.dataset.selectedValue !== this.options[index]) {
          const escaped = this.options[index].replace(/["\\]/g, "\\$&");
          const input = field.querySelector(`input[value="${escaped}"]`);
          if (input) {
            input.checked = true;
            if (typeof field.updateSelectedValue === "function") {
              field.updateSelectedValue();
            }
          }
        }
      });
    }
    updateMedia() {
      if (!this.currentVariant || !this.media) return;
      let slides = [];
      let thumbs = [];
      let i = 0;
      let a = 0;
      let s = 0;
      let r = 0;
      if (this.variantGroupImages && this.variantGroupImages.enable) {
        if ("slider" === this.media.mediaMode && this.slides) {
          this.slides.forEach((slide) => {
            const mediaEl = slide.querySelector("[data-media-id]");
            if (!mediaEl) return;
            const mediaId = mediaEl.dataset.mediaId;
            if (this.currentVariantMedia && this.currentVariantMedia.length > 0) {
              if (this.currentVariantMedia.includes(mediaId)) {
                slide.dataset.swiperSlideIndex = i++;
                slide.dataset.index = a++;
                if ("0" === slide.dataset.swiperSlideIndex) {
                  slide.classList.add("swiper-slide-active");
                }
                slides.push(slide);
              }
              if (!slide.classList.contains("media-type-image")) {
                slide.dataset.swiperSlideIndex = i++;
                slide.dataset.index = a++;
                slides.push(slide);
              }
            } else {
              slide.dataset.swiperSlideIndex = i++;
              slide.dataset.index = a++;
              slides.push(slide);
            }
          });
          this.media.slider.removeAllSlides();
          this.media.slider.appendSlide(slides);
          "layout-7" == this.layout
            ? this.media.slider.slideToLoop(1)
            : this.media.slider.slideToLoop(0);
          this.media.handleSlideChange();
          if (this.slidesNav) {
            this.slidesNav.forEach((slide) => {
              const mediaEl = slide.querySelector("[data-media-id]");
              if (!mediaEl) return;
              const mediaId = mediaEl.dataset.mediaId;
              if (this.currentVariantMedia && this.currentVariantMedia.length > 0) {
                if (this.currentVariantMedia.includes(mediaId)) {
                  slide.dataset.swiperSlideIndex = s++;
                  slide.dataset.index = r++;
                  if ("0" === slide.dataset.swiperSlideIndex) {
                    slide.classList.add("swiper-slide-thumb-active");
                  }
                  thumbs.push(slide);
                }
                if (!slide.classList.contains("media-type-image")) {
                  slide.dataset.swiperSlideIndex = s++;
                  slide.dataset.index = r++;
                  thumbs.push(slide);
                }
              } else {
                slide.dataset.swiperSlideIndex = s++;
                slide.dataset.index = r++;
                slide.classList.remove("swiper-slide-thumb-active");
                if ("0" === slide.dataset.swiperSlideIndex) {
                  slide.classList.add("swiper-slide-thumb-active");
                }
                thumbs.push(slide);
              }
            });
          }
          if (this.media.navSlider) this.media.navSlider.removeAllSlides();
          if (this.media.navSlider) this.media.navSlider.appendSlide(thumbs);
          if (this.media.navSlider) this.media.navSlider.slideToLoop(0);
          this.media.removeAttribute("data-media-loading");
          if (this.media.firstElementChild) {
            this.media.firstElementChild.style.opacity = 1;
          }
        } else {
          let index = 0;
          const list = this.media.querySelector(".m-product-media--list");
          if (!list) return;
          if (this.mediaItems) {
            this.mediaItems.forEach((item) => {
              const mediaEl = item.querySelector("[data-media-id]");
              if (!mediaEl) return;
              const mediaId = mediaEl.dataset.mediaId;
              if (this.currentVariantMedia && this.currentVariantMedia.length > 0) {
                if (this.currentVariantMedia.includes(mediaId)) {
                  item.dataset.index = index++;
                  slides.push(item);
                }
                if (!item.classList.contains("media-type-image")) {
                  item.dataset.index = index++;
                  slides.push(item);
                }
              } else {
                item.dataset.index = index++;
                slides.push(item);
              }
              list.innerHTML = "";
              slides.forEach((slide) => {
                if ("layout-2" == this.layout) {
                  slide.classList.remove("m-col-span-2");
                  if (0 == slide.dataset.index % 3) {
                    slide.classList.add("m-col-span-2");
                  }
                }
                list.append(slide);
              });
            });
          }
          this.media.removeAttribute("data-media-loading");
          if (this.media.firstElementChild) {
            this.media.firstElementChild.style.opacity = 1;
          }
        }
      } else if (parseInt(this.media.dataset.mediaSize) > 0) {
        this.media.setActiveMedia(this.currentVariant);
      }
      const lightboxItems = [];
      if (slides.length > 0) {
        slides.forEach((slide) => {
          if ("image" === slide.dataset.mediaType) {
            const media = slide.querySelector(".m-product-media");
            if (!media) return;
            const data = media.dataset;
            lightboxItems.push({
              src: data.mediaSrc,
              width: parseInt(data.mediaWidth),
              height: parseInt(data.mediaHeight),
              alt: data.mediaAlt,
              id: slide.dataset.index,
            });
          } else {
            lightboxItems.push({
              html: `<div class="pswp__${slide.dataset.mediaType}">${slide.innerHTML}</div>`,
              type: slide.dataset.mediaType,
              id: slide.dataset.index,
            });
          }
        });
      }
      if (this.media.lightbox) this.media.lightbox.destroy();
      if (this.media.handlePhotoswipe) this.media.handlePhotoswipe(lightboxItems);
      if (this.media.initPhotoswipe) this.media.initPhotoswipe();
    }
    updateBrowserHistory() {
      if (this.currentVariant && "false" !== this.dataset.updateUrl) {
        window.history.replaceState(
          {},
          "",
          `${this.productUrl}?variant=${this.currentVariant.id}`
        );
      }
    }
    updateVariantInput() {
      document
        .querySelectorAll(
          `#product-form-${this.sectionId}, #product-form-installment`
        )
        .forEach((form) => {
          const input = form.querySelector(this.selectors.variantIdInput);
          if (!input) return;
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
    }
    updatePickupAvailability() {
      if (!this.section) return;
      const pickup = this.section.querySelector("pickup-availability");
      if (!pickup) return;
      if (this.currentVariant && this.currentVariant.available) {
        pickup.fetchAvailability(this.currentVariant.id);
      } else {
        pickup.removeAttribute("available");
        pickup.innerHTML = "";
      }
    }
    removeErrorMessage() {
      const section = this.closest("section");
      if (!section) return;
      const form = section.querySelector("product-form");
      if (form && typeof form.handleErrorMessage === "function") {
        form.handleErrorMessage();
      }
    }
    updatePrice() {
      const onSaleClass = "m-price--on-sale";
      const soldOutClass = "m-price--sold-out";
      const container =
        (this.productInfo &&
          (this.productInfo.querySelector(".main-product__block-price") ||
            this.productInfo.querySelector(".product-block-group--price") ||
            this.productInfo.querySelector("[data-product-price]"))) ||
        null;
      if (!container) return;
      const priceWrapper = container.querySelector(".m-price");
      if (!priceWrapper) return;
      const {
        price,
        compare_at_price,
        unit_price,
        unit_price_measurement,
        available,
      } = this.currentVariant;
      const moneyFormat =
        (window.MinimogSettings && window.MinimogSettings.money_format) ||
        (window.theme && window.theme.moneyFormat);
      priceWrapper.classList.remove(onSaleClass, soldOutClass);
      if (compare_at_price && compare_at_price > price) {
        priceWrapper.classList.add(onSaleClass);
      }
      if (!available) priceWrapper.classList.add(soldOutClass);
      const format = (value) => {
        if (
          window.MinimogTheme &&
          window.MinimogTheme.Currency &&
          typeof window.MinimogTheme.Currency.formatMoney === "function"
        ) {
          return window.MinimogTheme.Currency.formatMoney(value, moneyFormat);
        }
        if (typeof formatMoney === "function") {
          return formatMoney(value, moneyFormat);
        }
        if (window.Shopify && typeof Shopify.formatMoney === "function") {
          return Shopify.formatMoney(value, moneyFormat);
        }
        return value;
      };
      const salePrice = container.querySelector(".m-price-item--sale");
      const comparePrices = container.querySelectorAll(".m-price-item--regular");
      const unitPrice = container.querySelector(".m-price__unit");
      if (salePrice) salePrice.innerHTML = format(price);
      comparePrices.forEach((el) => {
        el.innerHTML = format(compare_at_price || price);
      });
      if (unitPrice) {
        if (unit_price && unit_price_measurement) {
          unitPrice.classList.remove("m:hidden", "hidden");
          const unitEl = unitPrice.querySelector("[data-unit-price]");
          const baseEl = unitPrice.querySelector("[data-unit-price-base-unit]");
          if (unitEl || baseEl) {
            if (unitEl) unitEl.innerHTML = format(unit_price);
            if (baseEl) baseEl.innerHTML = this._getBaseUnit();
          } else {
            unitPrice.innerHTML =
              "<span>" +
              format(unit_price) +
              '</span><span aria-hidden="true">/</span><span data-unit-price-base-unit>' +
              this._getBaseUnit() +
              "</span>";
          }
        } else {
          unitPrice.classList.add("m:hidden");
        }
      }
    }
    _getBaseUnit = () => {
      const measurement =
        this.currentVariant && this.currentVariant.unit_price_measurement;
      if (!measurement) return "";
      return 1 === measurement.reference_value
        ? measurement.reference_unit
        : measurement.reference_value + measurement.reference_unit;
    };
    updateButton(disable = true, label) {
      const forms = document.querySelectorAll(
        `.product-form-${this.sectionId}`
      );
      forms &&
        forms.forEach((form) => {
          const button = form.querySelector('[name="add"]');
          const dynamicCheckout = form.querySelector(
            ".m-product-dynamic-checkout"
          );
          const text = form.querySelector(
            '[name="add"] > .m-add-to-cart--text'
          );
          if (!button) return;
          if (disable) {
            button.setAttribute("disabled", "disabled");
            button.classList.add("disabled");
            if (dynamicCheckout) dynamicCheckout.classList.add("disabled");
            if (label && text) text.textContent = label;
          } else {
            button.removeAttribute("disabled");
            button.classList.remove("disabled");
            if (dynamicCheckout) dynamicCheckout.classList.remove("disabled");
            if (text && window.MinimogStrings) {
              text.textContent = window.MinimogStrings.addToCart;
            }
          }
        });
    }
    updateProductMeta() {
      if (!this.currentVariant || !this.section) return;
      const { available, sku } = this.currentVariant;
      const strings = window.MinimogStrings || {};
      const availability = this.section.querySelector(
        this.selectors.productAvailability
      );
      const skuNode = this.section.querySelector(this.selectors.productSku);
      if (skuNode) skuNode.textContent = sku || "N/A";
      if (availability) {
        availability.textContent = available ? strings.inStock : strings.outOfStock;
        availability.classList[available ? "remove" : "add"](
          "m-product-availability--outofstock"
        );
      }
    }
    setUnavailable() {
      const form = document.getElementById(`product-form-${this.sectionId}`);
      if (!form) return;
      const button = form.querySelector('[name="add"]');
      const text = form.querySelector('[name="add"] > span.m-add-to-cart--text');
      const price = this.section && this.section.querySelector(".m-price");
      if (button && text && window.MinimogStrings) {
        text.textContent = window.MinimogStrings.unavailable;
      }
      if (price) price.classList.add("visibility-hidden");
    }
    hideSoldOutAndUnavailableOptions = () => {
      const soldOutClass = "m-product-option--node__soldout";
      const unavailableClass = "m-product-option--node__unavailable";
      const current = this.currentVariant;
      const optionNodes =
        this.domNodes && this.domNodes.optionNodes ? this.domNodes.optionNodes : [];
      if (!current || !this.productData || !optionNodes.length) return;
      const variants = this.productData.variants || [];
      const optionCount =
        this.productData.options && this.productData.options.length;
      optionNodes.forEach((node) => {
        const { optionPosition, value } = node.dataset;
        const position = Number(optionPosition);
        const isOptionTag = "OPTION" === node.tagName;
        let matches = [];
        if (position === optionCount) {
          const opts = Array.from(current.options);
          opts[optionCount - 1] = value;
          matches.push(getVariantFromOptionArray(this.productData, opts));
        } else {
          matches = variants.filter(
            (variant) =>
              variant.options[position - 1] === value &&
              variant.options[position - 2] === current["option" + (position - 1)]
          );
        }
        matches = matches.filter(Boolean);
        if (matches.length) {
          node.classList.remove(unavailableClass);
          if (isOptionTag) node.removeAttribute("disabled");
          const allSoldOut = matches.every((variant) => false === variant.available);
          node.classList[allSoldOut ? "add" : "remove"](soldOutClass);
        } else {
          node.classList.add(unavailableClass);
          if (isOptionTag) node.setAttribute("disabled", "true");
        }
      });
    };
    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(
          this.container.querySelector(
            '#productVariants[type="application/json"]'
          ).textContent
        );
      return this.variantData;
    }
    getVariantGroupImageData() {
      const node = this.container.querySelector(
        '#variantGroup[type="application/json"]'
      );
      if (!node) return this.variantGroupImages || null;
      this.variantGroupImages =
        this.variantGroupImages || JSON.parse(node.textContent);
      return this.variantGroupImages;
    }
    initOptionSwatches() {
      const settings = window.MinimogSettings || {};
      const colorSwatches = settings._colorSwatches || [];
      const imageSwatches = settings._imageSwatches || [];
      const nodes = this.domNodes && this.domNodes.optionNodes;
      if (!nodes) return;
      nodes.forEach((node) => {
        const { optionType, optionPosition, value } = node.dataset;
        const lower = value && value.toLowerCase();
        const variant =
          this.variantData &&
          this.variantData.find((item) => item[`option${optionPosition}`] === value);
        const variantImage =
          variant && variant.featured_image && variant.featured_image.src
            ? getSizedImageUrl(variant.featured_image.src, "100x")
            : null;
        const customImage = (imageSwatches.find((item) => item.key === lower) || {})
          .value;
        const customColor = (colorSwatches.find((item) => item.key === lower) || {})
          .value;
        const label = node.querySelector("label");
        if (!label) return;
        if (variantImage || customImage) label.classList.add("has-bg-img");
        switch (optionType) {
          case "default":
            label.style.backgroundImage = `url(${customImage || variantImage || ""})`;
            label.classList.remove("option-loading");
            break;
          case "image":
            label.style.backgroundImage = `url(${variantImage || customImage || ""})`;
            label.classList.remove("option-loading");
            break;
          case "color":
            label.style.backgroundColor = customColor || lower;
            if (customImage) label.style.backgroundImage = `url(${customImage})`;
            label.classList.remove("option-loading");
            break;
        }
      });
    }
  }
  customElements.define("variant-picker", e);
}

if (!customElements.get("variant-button")) {
  class VariantButton extends HTMLElement {
    constructor() {
      super();
      this.selectedSpan = this.querySelector(".option-label--selected");
      this.addEventListener("change", this.updateSelectedValue);
    }
    updateSelectedValue() {
      const checked = Array.from(this.querySelectorAll("input")).find(
        (input) => input.checked
      );
      if (!checked) return;
      this.value = checked.value;
      this.setAttribute("data-selected-value", this.value);
      if (this.selectedSpan) {
        this.selectedSpan.textContent = this.value;
        this.selectedSpan.classList.remove("m:text-color-error");
      }
    }
  }
  customElements.define("variant-button", VariantButton);

  if (!customElements.get("variant-select")) {
    class VariantSelect extends VariantButton {
      updateSelectedValue() {
        const select = this.querySelector("select");
        if (!select) return;
        this.value = select.value;
        this.setAttribute("data-selected-value", this.value);
        if (this.selectedSpan) {
          this.selectedSpan.textContent = this.value;
          this.selectedSpan.classList.remove("m:text-color-error");
        }
      }
    }
    customElements.define("variant-select", VariantSelect);
  }

  if (!customElements.get("variant-image")) {
    class VariantImage extends VariantButton {}
    customElements.define("variant-image", VariantImage);
  }

  if (!customElements.get("variant-color")) {
    class VariantColor extends VariantButton {}
    customElements.define("variant-color", VariantColor);
  }
}